/**
 * @generated SignedSource<<00ade8043e9e0158d86e4c87f2012c5a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FiltersGetProviderQuery$variables = {};
export type FiltersGetProviderQuery$data = {
  readonly sys_providers: ReadonlyArray<{
    readonly provider_id: number;
    readonly provider_name: string;
  }>;
};
export type FiltersGetProviderQuery = {
  response: FiltersGetProviderQuery$data;
  variables: FiltersGetProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "sys_providers",
    "kind": "LinkedField",
    "name": "sys_providers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FiltersGetProviderQuery",
    "selections": (v0/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FiltersGetProviderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4f1b1077435084461af39d57ad163191",
    "id": null,
    "metadata": {},
    "name": "FiltersGetProviderQuery",
    "operationKind": "query",
    "text": "query FiltersGetProviderQuery {\n  sys_providers {\n    provider_id\n    provider_name\n  }\n}\n"
  }
};
})();

(node as any).hash = "409b16a9642b539bd203847b5f685ee0";

export default node;
